import React from "react";
import { TextField, useTheme } from "@mui/material";

const TextArea = ({ id, label, value, onChange, errorText = null, rows = 4, disabled = false, mt = 0, mb = 0 }) => {
    const theme = useTheme();
    return (
        <TextField
            fullWidth
            multiline
            id={id}
            name={id}
            label={label}
            value={value ?? ""}
            onChange={onChange}
            error={Boolean(errorText)}
            helperText={errorText}
            disabled={disabled}
            rows={rows}
            margin="none"
            sx={{ marginTop: theme.spacing(mt), marginBottom: theme.spacing(mb) }}
        />
    );
}

export default TextArea;
